import { InputFormCallout, InputFormCalloutProps, Select } from "o4a-react";
import * as React from "react";
import { Text } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { AzureCloudLinkSummary, AzureSubscriptionSummary } from "../../gen/clients/mchub-azure-api-client";

export const enum Fields {
  cloudLinkId = "cloudLinkId",
}
export interface LinkSubscriptionPanelProps extends
  Pick<InputFormCalloutProps, "targetId" | "onClose" | "onSubmit" | "componentRef">
{
  subscription: AzureSubscriptionSummary;
  activeCloudLinks: AzureCloudLinkSummary[];
}

export const LinkSubscriptionPanel = ({
  subscription,
  activeCloudLinks,
  targetId,
  componentRef,
  onClose,
  onSubmit,
}: LinkSubscriptionPanelProps): JSX.Element => {
  const cloudLinkOptions = activeCloudLinks.map(cloudLink => ({
    id: cloudLink.id,
    text: cloudLink.ociTenancyName || cloudLink.name,
  }));

  return (
    <InputFormCallout
      componentRef={componentRef}
      title={Messages.createNewPanels.linkSubscription.title()}
      targetId={targetId}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <Text
        block
        styles={{
          root: {
            marginBottom: 18,
            fontStyle: "normal",
          },
        }}
        variant="medium"
      >
        {cloudLinkOptions.length > 1
          ? Messages.createNewPanels.linkSubscription.descriptionMultipleCloudLinks(subscription.name)
          : Messages.createNewPanels.linkSubscription.descriptionSingleCloudLink(subscription.name)}
      </Text>
      {cloudLinkOptions.length > 1 && (
        <Select
          defaultValue={activeCloudLinks.length === 1 ? [activeCloudLinks[0].id] : undefined}
          required
          fieldName={Fields.cloudLinkId}
          label={Messages.labels.ociTenant()}
          options={cloudLinkOptions}
        />
      )}
    </InputFormCallout>
  );
};
